import { AxiosInstance } from 'axios';

const setAcceptLanguageHeader = (instance: AxiosInstance) => {
    instance.interceptors.request.use((value) => {
        value.headers.common['Accept-Language'] = 'nl-NL';
        return value;
    });
};

export default setAcceptLanguageHeader;